module.exports = __webpack_public_path__ + "media/brands/zipp-8740f5a9.png";